import { Link, useTranslation } from "gatsby-plugin-react-i18next";
import { BackButtonWrapper } from "./styles";
import { AiFillLeftCircle } from "react-icons/ai";

const BackButton = ({ to }) => {
  const { t } = useTranslation();

  return (
    <BackButtonWrapper>
      <Link to={to}>
        <AiFillLeftCircle />
        <span> {t("goBackButton")}</span>
      </Link>
    </BackButtonWrapper>
  );
};

export default BackButton;
